import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";

import { DOCUMENTS_ROUTE_SEGMENTS } from "../../shared/routing/paths/documents";
import { DocumentsPage, DocumentsRoute } from "./route-elements";

export const DocumentsRoutes = {
  path: DOCUMENTS_ROUTE_SEGMENTS.root,
  element: <DocumentsRoute />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spinner />}>
          <DocumentsPage />
        </Suspense>
      ),
    },
  ],
};
